import React, { Component } from 'react';
import CheckDefecto from '../../../../../Common/Components/CheckDefecto';
import RadioButtonDefecto from '../../../../../Common/Components/RadioButtonDefecto2';
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';
import { relative } from 'path';

export default class CostoEmision extends Component {
    constructor(props) {
        super(props);

        this.ontestlaterchange = this.ontestlaterchange.bind(this);
    }

    ontestlaterchange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);

        if (regExp.test(value) || value.replace(/\s/g, "", "") == "") {
            if(dataset.code == "PorcBonificacionEmisionDesde" || dataset.code == "PorcBonificacionEmisionHasta" || dataset.code == "BonificacionEmisionDefault" ){
                if(value<99){
                    this.props.changeInput(dataset.code, value);
                }
            }else{
                this.props.changeInput(dataset.code, value);
            }
        }
    }

    render() {
        const { ontestlaterchange } = this;
        const { data, selectCheckBox, selectRadio } = this.props;
        const acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");
        const acentoAMin = ExpHelper.ConvertirCaracter("a");

        let errorCuotas
        let errorCuotasDefault
        let errorBonif
        let errorBonifDefault

        if(parseInt(data.CargoEnCuotasDesde) > 0 && parseInt(data.CargoEnCuotasHasta) > 0 && parseInt(data.CuotasDefault) > 0){
            errorCuotas =  !(parseInt(data.CargoEnCuotasDesde) <= parseInt(data.CargoEnCuotasHasta)) 
            if(!errorCuotas){
                errorCuotasDefault = !(parseInt(data.CuotasDefault) >= parseInt(data.CargoEnCuotasDesde) && parseInt(data.CuotasDefault) <= parseInt(data.CargoEnCuotasHasta))
            }
        }

        if(parseInt(data.PorcBonificacionEmisionDesde) > 0 && parseInt(data.PorcBonificacionEmisionHasta) > 0 && parseInt(data.BonificacionEmisionDefault) > 0){
            errorBonif =  !(parseInt(data.PorcBonificacionEmisionDesde) <= parseInt(data.PorcBonificacionEmisionHasta)) 
            if(!errorBonif){
                errorBonifDefault = !(parseInt(data.BonificacionEmisionDefault) >= parseInt(data.PorcBonificacionEmisionDesde) && parseInt(data.BonificacionEmisionDefault) <= parseInt(data.PorcBonificacionEmisionHasta))
            }

        }
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">{"Costo Emisi" + acentoLetraOminuscula + "n"}</label>

                    <RadioButtonDefecto
                        nombre={"COSTO_EMISION"}
                        descripcion={"Sin Cargo (SC)"}
                        valor={"SC"}
                        checked={(data.CostoEmision == "SC")}
                        referencia={"COSTO_EMISION_SC"}
                        selectRadio={(valor) => selectRadio("COSTO_EMISION_SC", valor)} />

                    <RadioButtonDefecto
                        nombre={"COSTO_EMISION"}
                        descripcion={"Bonificado Parcialmente"}
                        valor={"BP"}
                        checked={(data.CostoEmision == "BP")}
                        referencia={"COSTO_EMISION_BP"}
                        selectRadio={(valor) => selectRadio("COSTO_EMISION_BP", valor)} />

                    <div className="container-radio radio-margin">
                        <div className="row">
                            <div className="col-xs-3">
                                <label className="lbl-radio label-secondary">{"Rango de Bonificaci" + acentoLetraOminuscula + "n"}</label>
                            </div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={2}
                                    value={data.PorcBonificacionEmisionDesde}
                                    data-code="PorcBonificacionEmisionDesde"
                                    data-validation="[1-9]{1}\d{0,1}"
                                    disabled={(data.CostoEmision != "BP")}
                                    onChange={ontestlaterchange}
                                />
                            </div>

                            <div className="col-xs-1">
                                <label className="label-secondary">{"% a"}</label>
                            </div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={2}
                                    value={data.PorcBonificacionEmisionHasta}
                                    data-code="PorcBonificacionEmisionHasta"
                                    data-validation="[1-9]{1}\d{0,1}"
                                    disabled={(data.CostoEmision != "BP")}
                                    onChange={ontestlaterchange}
                                />
                            </div>
                            <div className="col-xs-1"><label>{"%"}</label></div>
                        </div>
                        <div className="row">
                            <div className="col-xs-3">
                                <label className="lbl-radio label-secondary">{"% de Bonificaci" + acentoLetraOminuscula + "n" + " por defecto"}</label>
                            </div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={2}
                                    value={data.BonificacionEmisionDefault}
                                    data-code="BonificacionEmisionDefault"
                                    data-validation="[1-9]{1}\d{0,1}"
                                    disabled={(data.CostoEmision != "BP")}
                                    onChange={ontestlaterchange}
                                />
                            </div>
                        </div>

                        {data.CostoEmision == "BP" && <div style={{ position: 'relative', left: '25px' }}>
                            <CheckDefecto
                                check={data.BonificacionEmisionDefaultIntefaz}
                                referencia={"BONEMISIONDEFINTER"}
                                selectCheckBox={(event) => selectCheckBox("BonificacionEmisionDefaultIntefaz", event.target.checked)}
                                />
                        </div>}
                                <div>
                                {(data.ERROR_PRODUCT["porcBonificacionEmision"] == false && errorBonif) &&
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <label className="error">{"El límite inferior debe ser menor o igual al límite superior."}</label>
                                        </div>
                                    </div>}
                                {(data.ERROR_PRODUCT["porcBonificacionEmision"] == false && errorBonifDefault) &&
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <label className="error">{"El valor por defecto debe estar entre el límite inferior y superior."}</label>
                                        </div>
                                    </div>}
                                {(data.ERROR_PRODUCT["porcBonificacionEmision"] == false && !errorBonifDefault && !errorBonif) &&
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <label className="error">{"Debe ingresar Bonificado Parcialmente."}</label>
                                        </div>
                                    </div>}
                                </div>
                    </div>

                    <RadioButtonDefecto
                        nombre={"COSTO_EMISION"}
                        descripcion={"Bonificado al 100%"}
                        valor={"BT"}
                        checked={(data.CostoEmision == "BT")}
                        referencia={"COSTO_EMISION_BT"}
                        selectRadio={(valor) => selectRadio("COSTO_EMISION_BT", valor)} />

                    <RadioButtonDefecto
                        nombre={"COSTO_EMISION"}
                        descripcion={"Sin Bonificar"}
                        valor={"SB"}
                        checked={(data.CostoEmision == "SB")}
                        referencia={"COSTO_EMISION_SB"}
                        selectRadio={(valor) => selectRadio("COSTO_EMISION_SB", valor)} />

                    {(data.CostoEmision == "BP" || data.CostoEmision == "SB" ) &&
                    <div style={{ position: 'relative', right: '5px' }}>
                        <CheckDefecto
                            nombre={"Cargo en Cuotas"}
                            check={data.CargoEnCuotas}
                            referencia={"BONCARGOCUOTAS"}
                            selectCheckBox={(event) => selectCheckBox("CargoEnCuotas", event.target.checked)}
                        />
                    </div>}

                    {(data.CostoEmision == "BP" || data.CostoEmision == "SB" ) &&
                    <div className="container-radio radio-margin">
                        <div className="row">
                            <div className="col-xs-3">
                                <label className="lbl-radio label-secondary">{"Cantidad de Cuotas"}</label>
                            </div>

                            <div className="col-xs-2" >
                                <input className="form-control"
                                    maxLength={1}
                                    value={data.CargoEnCuotasDesde}
                                    data-code="CargoEnCuotasDesde"
                                    data-validation="[2-9]{1}\d{0,1}"
                                    disabled={!data.CargoEnCuotas}
                                    onChange={ontestlaterchange}
                                />
                            </div>

                            <div className="col-xs-1"><label>{"a"}</label></div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={1}
                                    value={data.CargoEnCuotasHasta}
                                    data-code="CargoEnCuotasHasta"
                                    data-validation="[2-9]{1}\d{0,1}"
                                    disabled={!data.CargoEnCuotas}
                                    onChange={ontestlaterchange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-3">
                                <label className="lbl-radio label-secondary">{"Cantidad de cuotas por defecto"}</label>
                            </div>

                            <div className="col-xs-2">
                                <input className="form-control"
                                    maxLength={1}
                                    value={data.CuotasDefault}
                                    data-code="CuotasDefault"
                                    data-validation="[2-9]{1}\d{0,1}"
                                    disabled={!data.CargoEnCuotas}
                                    onChange={ontestlaterchange}
                                />
                            </div>
                        </div>


                        {data.CargoEnCuotas && <div style={{ position: 'relative', left: '25px' }}>
                            <CheckDefecto
                                check={data.CuotasDefaultInterfaz}
                                referencia={"BONCIECOSEMICUODEF"}
                                selectCheckBox={(event) => selectCheckBox("CuotasDefaultInterfaz", event.target.checked)}
                            />
                        </div>}
                        {(data.ERROR_PRODUCT["rangoCargoCuotas"] == false && errorCuotas) &&
                            <div className="row">
                                <div className="col-xs-12">
                                    <label className="error">{"El límite inferior debe ser menor o igual al límite superior."}</label>
                                </div>
                            </div>}
                        {(data.ERROR_PRODUCT["rangoCargoCuotas"] == false && errorCuotasDefault) &&
                            <div className="row">
                                <div className="col-xs-12">
                                    <label className="error">{"El valor por defecto debe estar entre el límite inferior y superior."}</label>
                                </div>
                            </div>}
                        {(data.ERROR_PRODUCT["rangoCargoCuotas"] == false && !errorCuotasDefault && !errorCuotas) &&
                            <div className="row">
                                <div className="col-xs-12">
                                    <label className="error">{"Debe ingresar Cargo en Cuotas."}</label>
                                </div>
                            </div>}
                    </div>}

                    {data.ERROR_PRODUCT["seleccionoCostoEmision"] == false &&
                        <label className="error">{"Debe seleccionar al menos un costo de emisi" + acentoLetraOminuscula + "n."}</label>}
                </div>
            </div>
        );
    }
}